import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री. संजय बालाजी पुरके", designation: "ग्रामपंचायत सदस्य बेला", phone: "+91-9673082899", imageUrl: "/images/sanjay.jpg" },
  { name: "श्री. योगेश बाळकृष्ण गाते", designation: "ग्रामपंचायत सदस्य बेला", phone: "+91-9765622603 ", imageUrl: "/images/suraj.jpg" },
  { name: "श्री. राजू दत्तू रोडे", designation: "ग्रामपंचायत सदस्य बेला", phone: "+91-9545167838 ", imageUrl: "/images/raju.jpg" },
  { name: "श्री. श्री.नितीन सूर्यमान बालपांडे", designation: "ग्रामपंचायत सदस्य बेला", phone: "+91-9545167838 ", imageUrl: "/images/nitin.jpeg" },
  { name: "श्री. सुरज आनंदराव कांबळे", designation: "ग्रामपंचायत सदस्य बेला", phone: "+91-9545167838 ", imageUrl: "/images/yogesh.jpeg" },
  { name: "श्री. अभिनव परसरामजी गोळघाटे", designation: "ग्रामपंचायत सदस्य बेला", phone: "+91-9975795977 ", imageUrl: "/images/abhinav.jpg" },
  { name: "श्री. मिलींद कवडुजी सातकर", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-9158612100 ", imageUrl: "/images/milind.jpg" },
  
  
  { name: "सौ. कल्पना रमण पादाडे", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-9130414572 ", imageUrl: "/images/kalpana.jpg" },
  { name: "सौ. शालू कवडूजी लांडे", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-8080619014 ", imageUrl: "/images/shalu.jpg" },
  { name: "सौ. नाजुका यशवंत धनकासार", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-7822895460 ", imageUrl: "/images/najuk.jpg" },
  { name: " सौ. सुनीता अरुण कावळे", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-9764138994 ", imageUrl: "/images/sunita.jpg" },
  { name: " सौ.शीला बळीराम गंधारे", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-9673616865 ", imageUrl: "/images/shila.jpg" },
  { name: "सौ. माया शंकर आंबटकर", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-9552548103 ", imageUrl: "/images/maya.jpg" },
  { name: " सौ.रेखा विठ्ठल उरकुडे", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-9158970427 ", imageUrl: "/images/rekha.jpg" },
  { name: "सौ.हेमलता दशरथ झगडे", designation: "ग्रामपंचायत सदस्या बेला", phone: "+91-7822860654 ", imageUrl: "/images/hemlata.jpg" },
];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;